import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Pillars from "@/components/Pillars";
import Brands from "@/components/Brands";
import Team from "@/components/Team";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import "@/App.css";

const Home = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <About />
      <Pillars />
      <Brands />
      <Team />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <LanguageProvider>
      <div className="App bg-[var(--ps-bg)] text-[var(--ps-text)] min-h-screen font-body">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#14151a",
              border: "1px solid rgba(197,168,128,0.35)",
              color: "#f4f4f5",
              borderRadius: "0px",
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
